
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'
    import EditBackStockAgeRule from './edit-back-stock-age-rule.vue'


    class BackStockAgeRuleRequest extends PageRequest {
        storeId?: number;
        userCode: string;
    }

    @Component({
        name: "BackStockAgeRuleRequest",
        components: { EditBackStockAgeRule  }
    })
    export default class BackStockAge extends AbpBase {
        storeaddressList: Array<storeaddressInfo> = [];
        pagerequest: BackStockAgeRuleRequest = new BackStockAgeRuleRequest();
        editBackStockAgeRuleModelShow: boolean = false;

        get list() {
            return this.$store.state.backStockAgeRules.list;
        };
        get loading() {
            return this.$store.state.backStockAgeRules.loading;
        }


        pageChange(page: number) {
            this.$store.commit('backStockAgeRules/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backStockAgeRules/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.backStockAgeRules.currentPage = 1;
            this.getpage();
        }
        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            await this.$store.dispatch({
                type: 'backStockAgeRules/getAll',
                data: this.pagerequest
            })

        }

        async delete(data) {
            this.$Modal.confirm({
                title: "删除规则", content: "确定要删除" + data.name + "这条规则么？", onOk: async () => {
                    await this.$store.dispatch({
                        type: 'backStockAgeRules/delete',
                        data: {id:data.id}
                    });
                    this.getpage();
                }
            });
        }

        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            if (this.storeaddressList.length == 1) {
                this.pagerequest.storeId = this.storeaddressList[0].id;
            }
            else {
                this.storeaddressList.push(a);
                this.pagerequest.storeId = null;
            }
        }

        get pageSize() {
            return this.$store.state.backStockAgeRules.pageSize;
        }
        get totalCount() {
            return this.$store.state.backStockAgeRules.totalCount;
        }
        get currentPage() {
            return this.$store.state.backStockAgeRules.currentPage;
        }

        async add(data: any) {
            var model = null;

            if (data.id) {
                model = await this.$store.dispatch({
                    type: 'backStockAgeRules/get',
                    data: { id: data.id }
                });
                model.storename = data.storeName;
            } else {
                if (!this.pagerequest.storeId) {
                    this.$Message.error("请选择仓库！");
                    return;
                }
                model = await this.$store.dispatch({
                    type: 'backStockAgeRules/initial',
                    data: {}
                });
                var storeId = this.pagerequest.storeId;
                var name = this.storeaddressList.find(function (item) { return item.id == storeId }).storeName;
                model.storeId = storeId;
                model.storename = name;
            }
            this.$store.state.backStockAgeRules.model = model;
            this.editBackStockAgeRuleModelShow = true;
        }

        columns = [
            {
                title: '备货入库仓库',
                key: 'storeName',
                width: 150,
            },
            {
                title: '名称',
                key: 'name',
                width: 150,
            },
{
                title: '用户编码',
                key: 'userList',
                width: 150,
            },
            {
                title: '单SKU最小立方',
                key: 'cube',
                width: 150,
            },
            {
                title: '默认SKU立方',
                key: 'singleCube',
                width: 150,
            },
            {
                title: '时间',
                width: 230,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "创建时间:" + (params.row.creationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.creationTime)))), h('h3', "更新时间:" + (params.row.updateTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.updateTime))))])
                }
            },
            {
                title: '操作',
                width: 120,
                fixed: 'left',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: "inline-block",

                            },
                            on: {
                                click: () => {
                                    this.add(params.row);
                                   // _this.checkmodel(params.row);

                                }
                            }

                        }, "编辑"),
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: "inline-block",

                            },
                            on: {
                                click: () => {
                                    this.delete(params.row);
                                    // _this.checkmodel(params.row);

                                }
                            }

                        }, "删除")
                    ]);

                }
            }
        ]
        async created() {
            await this.getData();
            this.getpage();
        }
    }
